
$( document ).ready(function() {
  $('.slide-pro').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
     infinite: false,
    adaptiveHeight: false,
        dots: true,
    arrows:false
});

if ($(window).width() < 767) {

 $('#tabs-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
     infinite: false,
    adaptiveHeight: false,
        dots: false,
    arrows:false,
          responsive: [
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
           ]
});

  
// live slider
  $('.live_slider').slick({
  slidesToShow: 2,
  slidesToScroll: 1,
    arrows:false,
    infinite: false,
});
  
}

});

  
     




